import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { IMedicalInfoDetailed } from '../../../../../../interfaces/MedicalInfo/IMedicalInfoDetailed';
import { MedicalHistoryService } from '../../../../../../services/medicalHistory.service';
import { MedicalHistoryAddEditComponent } from './medical-history-add-edit/medical-history-add-edit.component';
import { TranslateService } from '@ngx-translate/core';
import { COLORS } from 'src/styles/colors';
import { SwalToastService } from 'src/app/services/swal.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-medical-history',
    templateUrl: './medical-history.component.html',
    styleUrls: ['./medical-history.component.css'],
    standalone: false
})
export class MedicalHistoryComponent {
  public addComp = MedicalHistoryAddEditComponent;

  private destroy$ = new Subject<void>();

  medicalAlerts?: IMedicalInfoDetailed[];
  isLoading: boolean = false;

  constructor(
    private readonly medicalHistoryService: MedicalHistoryService,
    private readonly translate: TranslateService,
    private readonly swalToastService: SwalToastService,
    private readonly permissionService: PermissionService
  ) {}

  hasPermission(permission: string[]): boolean {
    return this.permissionService.can(permission);
  }

  openModalFun(item?: IMedicalInfoDetailed) {
    this.medicalHistoryService.medicalHistoryModalSub.next(true);
    this.medicalHistoryService.medicalHistoryEditSub.next(item);
  }

  deleteFun(medicalAlertId: number) {
    Swal.fire({
      text: `${this.translate.instant(
        'deletePlaceholder1'
      )} ${this.translate.instant('Medical History')}?`,
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: `${this.translate.instant('Cancel')}`,
      confirmButtonText: `${this.translate.instant('Ok')}`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.medicalHistoryService
          .deleteMedicalHistory(medicalAlertId.toString())
          .subscribe({
            next: (d) => {
              this.swalToastService.toastSuccess(
                'Medical History deleted successfully'
              );
              this.medicalHistoryService.deleteMedicalHistoryFromTable(
                medicalAlertId.toString()
              );
            },
            error: (err) => {
              this.swalToastService.toastError(
                'Unable to delete Medical History'
              );
            },
          });
      } else if (result.isDenied) {
        Swal.fire(
          `${this.translate.instant('Medical history is not deleted')}`,
          '',
          'info'
        );
      }
    });
  }
  ngOnInit() {
    this.medicalHistoryService.medicalHistoryLoadingSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });

    this.medicalHistoryService.medicalHistoryDataSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: IMedicalInfoDetailed[]) => {
        this.medicalAlerts = data;
      });

    this.medicalHistoryService.getData();
  }
}
